// extracted by mini-css-extract-plugin
export default {"SimAlchemy":"BqPxNbSmjjZ4kWOmsWXN"};